import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import isString from 'lodash/isString';

var isFilledString = function isFilledString(str) {
  return isString(str) && str.length > 0;
};
var getNumbersOnlyString = function getNumbersOnlyString(v) {
  return v.replace(/[^0-9]/g, '');
};
var getNumberString = function getNumberString(v) {
  var _context, _context2;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    addComma: false,
    maxDecimalDigits: 0
  };
  var _options$addComma = options.addComma,
    addComma = _options$addComma === void 0 ? false : _options$addComma,
    _options$maxDecimalDi = options.maxDecimalDigits,
    maxDecimalDigits = _options$maxDecimalDi === void 0 ? 0 : _options$maxDecimalDi;
  var dotIndex = _indexOfInstanceProperty(v).call(v, '.');
  if (maxDecimalDigits === 0 || dotIndex === -1) {
    var _integerPart = getNumbersOnlyString(v);
    return addComma && _integerPart ? Number(_integerPart).toLocaleString() : _integerPart;
  }
  var integerPart = getNumbersOnlyString(_sliceInstanceProperty(v).call(v, 0, dotIndex)) || '0';
  var decimalPart = _sliceInstanceProperty(_context = getNumbersOnlyString(_sliceInstanceProperty(v).call(v, dotIndex + 1))).call(_context, 0, maxDecimalDigits);
  return _concatInstanceProperty(_context2 = "".concat(addComma ? Number(integerPart).toLocaleString() : integerPart, ".")).call(_context2, decimalPart);
};

export { getNumberString, getNumbersOnlyString, isFilledString };
